module.exports = __webpack_public_path__ + "static/img/enterprise-normal-hover.bf285658.png";